import { connect } from 'react-redux'

import CreatePromotion from '../../../components/promotions/create/CreatePromotion'

import { createPromotion } from '../../../state/actions/organizations'
import { fetchServiceList } from '../../../state/actions/services'

import { IStoreState, ICreatePromotion } from '../../../types/index'

const mapStateToProps = (state: IStoreState) => {
  const currentOrgId: string = state.organizations.currentOrgId as string
  return {
    orgId: currentOrgId,
    services: Object.values(state.service.items),
    loading: state.organizationPromotions.metadata.processingCreation
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchServices: (orgId: string) => {
      dispatch(fetchServiceList('active', orgId))
    },
    createPromotion: (promotion: ICreatePromotion) => dispatch(createPromotion(promotion))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatePromotion)



// WEBPACK FOOTER //
// ./src/containers/promotions/create/CreatePromotion.ts